import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import {
  PlusCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  RetweetOutlined,
  QuestionOutlined
} from '@ant-design/icons';
import './Styles.css';

const BotaoAcaoFlutuante = ({ onBotaoAcaoClick, user }) => {
  const [showActions, setShowActions] = useState(false);
  const [labelEncerrarAtendimento, setLabelEncerrarAtendimento] = useState('Encerrar atendimento');
  const wrapperRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setLabelEncerrarAtendimento(window.innerWidth <= 400 ? 'Encerrar' : 'Encerrar atendimento');
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowActions(false);
        clearTimeout(timeoutRef.current);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => document.removeEventListener('click', handleClickOutside, true);
  }, []);

  useEffect(() => {
    if (showActions) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setShowActions(false);
      }, 10000);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [showActions]);

  const handleOptionClick = (action) => {
    setShowActions(false);
    clearTimeout(timeoutRef.current);
    onBotaoAcaoClick(action, user);
  };

  const toggleActions = () => {
    setShowActions((prev) => !prev);
  };

  return (
    <div className="bloco-botao-acoes">
      <Button
        className="btn-adicionar-atendimento"
        shape="circle"
        type="link"
        onClick={() => onBotaoAcaoClick('Adicionar Atendimento', user)}
      >
        <PlusCircleOutlined className="btn-adicionar-atendimento-icone" />
      </Button>

      <div className="grupo-encerrar-e-opcoes" ref={wrapperRef}>
        {showActions && (
          <div className="botoes-opcoes animar">
            <Button
              icon={<CheckOutlined />}
              onClick={() => handleOptionClick('vendeu')}
              className="botao-opcao botao-venda"
            >
              Venda
            </Button>
            <Button
              icon={<CloseOutlined />}
              onClick={() => handleOptionClick('nao-vendeu')}
              className="botao-opcao botao-perda"
            >
              Perda
            </Button>
            <Button
              icon={<RetweetOutlined />}
              onClick={() => handleOptionClick('troca')}
              className="botao-opcao botao-troca"
            >
              Troca
            </Button>
            <Button
              icon={<QuestionOutlined />}
              onClick={() => handleOptionClick('outros')}
              className="botao-opcao botao-outros"
            >
              Outros
            </Button>
          </div>
        )}

        <Button
          type="danger"
          onClick={toggleActions}
          className="btn-encerrar"
        >
          {labelEncerrarAtendimento}
        </Button>
      </div>
    </div>
  );
};

export default BotaoAcaoFlutuante;
